import React from 'react';


const EscalationHeatMap = ({ data }) => {
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const hours = ['12am', '3am', '6am', '9am', '12pm', '3pm', '6pm', '9pm'];

  const getIntensityColor = (value) => {
    if (value >= 80) return 'bg-error';
    if (value >= 60) return 'bg-warning';
    if (value >= 40) return 'bg-accent';
    if (value >= 20) return 'bg-secondary';
    return 'bg-muted';
  };

  const getIntensityOpacity = (value) => {
    return `opacity-${Math.min(100, Math.max(20, value))}`;
  };

  return;


















































































};

export default EscalationHeatMap;